module.exports = __webpack_public_path__ + "img/servigua.c6b25665.jpg";